// TRANSLATIONS
import en from './i18n/en'
import it from './i18n/it'
import sl from './i18n/sl'
import de from './i18n/de'
import fr from './i18n/fr'
import i18n from '@/providers/i18n'

for (let [lang, bundle] of Object.entries({en, it, sl, de, fr})) {
  i18n.i18next.addResourceBundle(lang, 'validation', bundle);
}


// WEBPACK FOOTER //
// ./src/providers/validation/index.js